import { BboxType } from '../../../types/bbox';
import { State } from '../../../types/state';

export const suggestedBboxesForPage = (page: number) => (state: State) =>
  state.bbox[page] ?? ([] as BboxType[]);
